export default "__VITE_ASSET__DQs6$02U__"